<template>
<div>
  <div class="breadcrumb-list">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active">Map</li>
    </ol>
  </div>
  <div class="maping-page">
    <div class="maping-page-lft">
      <ul class="map-list">
        <li>
          <a href="#">
            <div class="list-top">
              <strong class="name">Name</strong>
              <time class="date" datetime="2020-02-5">2020-02-5</time>
            </div>
            <div class="list-bottom">
              <span class="desg"><i class="ico ico-fill-circle"></i>Cricket Updater</span>
              <time class="date" datetime="2020-02-5">15:56:44 -  17:07:14 <span>(8hr)</span></time>
            </div>
          </a>
        </li>
        <li class="active">
          <a href="#">
            <div class="list-top">
              <strong class="name">Name</strong>
              <time class="date" datetime="2020-02-5">2020-02-5</time>
            </div>
            <div class="list-bottom">
              <span class="desg"><i class="ico ico-fill-circle"></i>Cricket Updater</span>
              <time class="date" datetime="2020-02-5">15:56:44 -  17:07:14 <span>(8hr)</span></time>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <div class="list-top">
              <strong class="name">Name</strong>
              <time class="date" datetime="2020-02-5">2020-02-5</time>
            </div>
            <div class="list-bottom">
              <span class="desg"><i class="ico ico-fill-circle"></i>Cricket Updater</span>
              <time class="date" datetime="2020-02-5">15:56:44 -  17:07:14 <span>(8hr)</span></time>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="maping-page-content">
      <div class="map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.152524511709!2d74.34861491533735!3d31.519970554315144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190473981b4847%3A0x15e8388505fc21ac!2sSixlogics%20Pakistan!5e0!3m2!1sen!2s!4v1658989103451!5m2!1sen!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../router/router'
export default {
  data() {
    return {

    }
  },
  serverPrefetch() {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
